module.exports = __webpack_public_path__ + "static/img/footer1.21d0110.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/footer1.png
// module id = q0I5
// module chunks = 1